import React, { useContext } from 'react';

import useStyles from 'hooks/useStyles';
import CourseContext from 'routes/course/components/CourseContext';
import { PlayerArrow } from 'components/Icon';

import styles from './CourseCover.scss';

function CourseCover() {
  useStyles(styles);

  const { pictureUrl, currentLesson, openPaywallModal } = useContext(
    CourseContext,
  );

  const isTrailer = !currentLesson.id;

  if (isTrailer) {
    return (
      <div
        className={styles.root}
        style={{ backgroundImage: `url(${pictureUrl})` }}
      />
    );
  }

  const lessonCoverUrl = currentLesson.previewImageUrl || pictureUrl;

  return (
    <div
      className={styles.root}
      style={{ backgroundImage: `url(${lessonCoverUrl})` }}
      onClick={openPaywallModal}
    >
      <div className={styles.playerArrow}>
        <PlayerArrow className={styles.playIcon} />
      </div>
    </div>
  );
}

export default CourseCover;
